import themeColors from '@/assets/theme/colors'

const classes = {
  embla: {
    position: 'relative' as 'relative',
    backgroundColor: 'transparent',
    padding: '0px',
    width: '100%'
  },
  emblaViewport: {
    overflow: 'hidden'
  },
  emblaContainer: {
    display: 'flex',
    alignItems: 'stretch'
  },
  emblaSlide: {
    position: 'relative' as 'relative',
    display: 'flex',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingBottom: '0.5rem',
    boxSizing: 'border-box' as 'border-box'
  },
  emblaButton: {
    outline: 0,
    cursor: 'pointer',
    backgroundColor: 'rgba(255,255,255,0.85)',
    boxShadow: '0 1px 6px rgba(0,0,0,0.15)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    touchAction: 'manipulation',
    position: 'absolute' as 'absolute',
    top: '50%',
    zIndex: 20,
    transform: 'translateY(-50%)',
    border: 0,
    width: '34px',
    height: '34px',
    padding: 0
  },
  arrowButtonColor: {
    color: themeColors.gray.dark,
    '&:hover': {
      color: themeColors.info.main
    }
  }
}

export default classes
